import { useState, useEffect } from "react";
import { Phone } from "react-feather";
import styles from "./identityVoice.module.css";

const IdentityVoiceCallBar = ({ call, callPartnerName, onHangup }) => {
  const [callStatus, setCallStatus] = useState("connecting");
  const [durationSeconds, setDurationSeconds] = useState(0);

  useEffect(() => {
    if (!call) return;

    const handleRinging = () => setCallStatus("ringing");
    const handleAccept = () => {
      setCallStatus("accept");
    };
    const handleDisconnect = () => {
      setCallStatus("disconnect");
      onHangup && onHangup();
    };
    const handleError = (error) => {
      console.log("[IDENTITY VOICE] call error", error);
      setCallStatus("disconnect");
      onHangup && onHangup();
    };

    call.on("ringing", handleRinging);
    call.on("accept", handleAccept);
    call.on("disconnect", handleDisconnect);
    call.on("error", handleError);

    return () => {
      call.off("ringing", handleRinging);
      call.off("accept", handleAccept);
      call.off("disconnect", handleDisconnect);
      call.off("error", handleError);
    };
  }, [call]);

  useEffect(() => {
    if (callStatus !== "accept") return;
    const interval = setInterval(() => {
      setDurationSeconds((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [callStatus]);

  const formatDuration = (totalSeconds) => {
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  if (!call || callStatus === "disconnect") return null;

  return (
    <div className={`${styles.CallBar}`}>
      <div className={`${styles.CallBarDetails}`}>
        <p className={`${styles.Name}`}>{callPartnerName}</p>
        <p className={`${styles.StatusText}`}>
          {callStatus === "connecting" && "Connecting…"}
          {callStatus === "ringing" && "Ringing…"}
          {callStatus === "accept" && formatDuration(durationSeconds)}
        </p>
      </div>
      <button
        className={`${styles.HangupBU}`}
        onClick={() => {
          call.disconnect();
        }}
      >
        <Phone />
      </button>
    </div>
  );
};

export default IdentityVoiceCallBar;
